export default[
    {
        path: '/avuso/lista',
        name: 'lista do recibo avuso', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/avuso/cadastro',
        name: 'cadastro recibo avuso', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/avuso/editar/:id',
        name: 'editar recibo avuso', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]